import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  model,
} from '@angular/core';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-auth-data-sitter-dialog',
  standalone: true,
  imports: [
    CommonModule,
    DialogComponent,
    ButtonComponent,
    TextareaModule,
    InputTextModule,
    ReactiveFormsModule,
  ],
  templateUrl: './AuthDataSitterDialog.component.html',
  styleUrl: './AuthDataSitterDialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthDataSitterDialogComponent {
  readonly #fb = inject(FormBuilder);
  readonly #authService = inject(AuthService);
  isDialogVisible = model.required<boolean>();

  form = this.#fb.group({
    userData: ['', Validators.required],
    locationsIds: ['', Validators.required],
    regionsIds: ['', Validators.required],
  });

  handleDialogClose() {
    this.isDialogVisible.set(false);
  }

  submit() {
    localStorage.setItem(
      this.#authService.userDataKey,
      this.form.value.userData as string,
    );
    localStorage.setItem(
      'selectedLocationIds',
      this.form.value.locationsIds as string,
    );
    localStorage.setItem(
      'selectedRegionsIds',
      this.form.value.regionsIds as string,
    );
    window.location.reload();
    this.handleDialogClose();
  }
}
